import { default as momentLib } from 'moment'

momentLib.locale('nl')

export const moment = momentLib